import { pgTable, uuid, text, integer, numeric, timestamp, index, bigint, uniqueIndex, primaryKey, } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export const llmUsage = pgTable("llm_usage", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    requestId: uuid("request_id"),
    provider: text("provider").notNull(),
    model: text("model").notNull(),
    inputTokens: integer("input_tokens"),
    outputTokens: integer("output_tokens"),
    totalTokens: integer("total_tokens"),
    costUsd: numeric("cost_usd", { precision: 10, scale: 4 }),
    status: text("status").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    // Composite unique to avoid duplicate rows per (company, request, status)
    uniquePerStatus: uniqueIndex("llm_usage_unique_per_status").on(table.companyId, table.requestId, table.status),
    createdIdx: index("llm_usage_created_idx").on(table.createdAt),
}));
export var LLMCostEnforcement;
(function (LLMCostEnforcement) {
    LLMCostEnforcement["NONE"] = "none";
    LLMCostEnforcement["SOFT"] = "soft";
    LLMCostEnforcement["HARD"] = "hard";
})(LLMCostEnforcement || (LLMCostEnforcement = {}));
export const orgLlmLimits = pgTable("org_llm_limits", {
    companyId: uuid("company_id")
        .primaryKey()
        .references(() => organisations.id, { onDelete: "cascade" }),
    period: text("period").notNull().default("month"),
    tokenBudget: integer("token_budget"),
    costBudgetUsd: numeric("cost_budget_usd", { precision: 10, scale: 2 }),
    enforcement: text("enforcement")
        .notNull()
        .default(LLMCostEnforcement.SOFT)
        .$type(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
});
export const orgLlmUsageCounters = pgTable("org_llm_usage_counters", {
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    period: text("period").notNull(),
    windowStart: timestamp("window_start", { withTimezone: true }).notNull(),
    tokensTotal: bigint("tokens_total", { mode: "number" }).notNull().default(0),
    costTotal: numeric("cost_total", { precision: 12, scale: 4 }).notNull().default("0"),
    lastAlertThreshold: integer("last_alert_threshold"),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    pk: primaryKey({
        name: "org_llm_usage_counters_pk",
        columns: [table.companyId, table.period, table.windowStart],
    }),
}));
export const llmPricing = pgTable("llm_pricing", {
    provider: text("provider").notNull(),
    model: text("model").notNull(),
    priceInPer1k: numeric("price_in_per_1k", { precision: 10, scale: 4 }).notNull(),
    priceOutPer1k: numeric("price_out_per_1k", { precision: 10, scale: 4 }).notNull(),
    effectiveFrom: timestamp("effective_from", { withTimezone: true }).notNull(),
    effectiveTo: timestamp("effective_to", { withTimezone: true }),
}, table => ({
    pk: primaryKey({
        name: "llm_pricing_pk",
        columns: [table.provider, table.model, table.effectiveFrom],
    }),
}));
